/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...


var myVar = setInterval(myTimer, 500);
function myTimer() {
  if( $('.product-single__box__block.product-single__box__block--buy_buttons delivery-promise-wc').length ) {
    console.log('delivery-promise-wc');
   // $('.product-single__box__block.product-single__box__block--buy_buttons delivery-promise-wc').css("margin-bottom",'-20px');
    clearInterval(myVar);
  }
}


$(document).ready(function(){


   jQuery(".footer-block-linklist .footer-nav__title").click(function(){
      console.log('footer-block__heading click');
      if ($(this).hasClass("open")) {
        $(this).removeClass("open");
        jQuery(this).next().removeClass("active");
      } else {
        $(this).addClass("open");
        jQuery(this).next().addClass("active");
      }	  
  });



    
});

